import $ from "cash-dom"

export default class BlockBgFadeModule {

    static name = 'blockbgfade'

    constructor(node) {

        this.$node = $(node);
        
        $(window).on('scroll', this.handleScroll);
        this.handleScroll();
    }
    
    
    handleScroll = (e) => {
        //die Intro-Partikel werden bei 45% "3D" – da soll das Bild ganz ausgeblendet sein
        const opacity = 1 - Math.min(1, (window.pageYOffset / (window.innerHeight*0.45)));
        this.$node.find('.block__bg').css('opacity', opacity);
    }
}